import { render } from "./Clouds.vue?vue&type=template&id=10481346"
import script from "./Clouds.vue?vue&type=script&lang=ts"
export * from "./Clouds.vue?vue&type=script&lang=ts"
script.render = render

export default script